var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83331 4.72469C2.83331 3.31543 3.98957 2.16669 5.40739 2.16669H10.5872C12.0055 2.16669 13.16 3.31538 13.1666 4.72231L13.1667 4.72469L13.1666 12.2369C13.1666 12.8303 12.9491 13.3748 12.4662 13.657C11.9844 13.9385 11.4026 13.8629 10.8828 13.5757C10.8828 13.5756 10.8828 13.5757 10.8828 13.5757L8.25667 12.1286C8.21362 12.1043 8.12273 12.0771 8.00199 12.0771C7.88175 12.0771 7.78753 12.1041 7.73967 12.1306L5.11674 13.5759L5.11517 13.5768C4.59485 13.861 4.01406 13.9337 3.53374 13.653C3.0517 13.3713 2.83331 12.829 2.83331 12.2369V4.72469ZM5.40739 3.16669C4.5362 3.16669 3.83331 3.87335 3.83331 4.72469V12.2369C3.83331 12.6046 3.9615 12.7447 4.03828 12.7896C4.11672 12.8354 4.30679 12.8787 4.63503 12.6996C4.63525 12.6994 4.63548 12.6993 4.6357 12.6992L7.25549 11.2556C7.25572 11.2555 7.25596 11.2554 7.25619 11.2552C7.25616 11.2553 7.25622 11.2552 7.25619 11.2552C7.48757 11.1274 7.75847 11.0771 8.00199 11.0771C8.2444 11.0771 8.5151 11.1269 8.74554 11.2562L11.3658 12.7001C11.6949 12.8819 11.8847 12.8386 11.9617 12.7936C12.0376 12.7492 12.1666 12.6086 12.1666 12.2369V4.72595C12.162 3.87278 11.4575 3.16669 10.5872 3.16669H5.40739Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.3755f317.svg";
export { ForwardRef as ReactComponent };